import * as React from 'react';
import { Link } from 'react-router-dom';
import { programRoute } from '../../ClientRoutes';
import { Program } from '../../ProgramStore/Types';
import { AlreadyTranslated, T } from '../../Translations';
import ArrowRightIcon from '../Cutesies/ArrowRightIcon';
import ActionPlanDownLoadLink from './ActionPlanDownLoadLink';
import * as style from './style.module.css';

interface Props {
  programDetail: Program;
}

const CompletedProgramOverviewHeader: React.FC<Props> = ({ programDetail }) => {
  return (
    <div className={style.header}>
      <Link to={programRoute(programDetail.id)} data-testid="program-overview-link">
        <h3 className={style.title} data-test-program-title={programDetail.title.text}>
          <AlreadyTranslated content={programDetail.title} />
        </h3>
        <button className={style.overviewButton}>
          <T kind="Overview" />
          <div className={style.buttonIcon}>
            <ArrowRightIcon />
          </div>
        </button>
      </Link>
      <ActionPlanDownLoadLink programDetail={programDetail} />
    </div>
  );
};

export default CompletedProgramOverviewHeader;
